import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatEUR } from "@/lib/api";
import { CommissionLines, PaymentForm, StatusPill } from "@/components/commissions/CommissionParts";

/** Fiche dossier — bloc Commission (lecture + enregistrement d'un paiement si acquise). */
export function CommissionBlock({ dossierId, refreshKey }) {
  const [c, setC] = useState(undefined);
  const [paying, setPaying] = useState(false);
  useEffect(() => { api.get(`/commissions/dossier/${dossierId}`).then((r) => setC(r.data.commission)).catch(() => setC(null)); }, [dossierId, refreshKey]);
  if (c === undefined || c === null) return null;
  const payable = ["acquise", "partiellement_payee"].includes(c.status);
  return (
    <div className="card-base p-5 md:p-6 mb-4" data-testid="commission-block">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div><div className="overline">Commission</div><div className="font-display text-lg font-extrabold text-slate-900 tabular-nums">{formatEUR(c.total)}</div></div>
        <div className="flex items-center gap-2"><StatusPill status={c.status} testid="commission-block-status" /><Link to="/commissions" className="btn-ghost" data-testid="commission-block-open">Toutes</Link></div>
      </div>
      <CommissionLines commission={c} testid="commission-block-lines" />
      <div className="text-[12px] text-slate-500 mt-3" data-testid="commission-block-hint">
        {c.status === "previsionnelle" ? "Acquise dès la saisie de la date d'encaissement. Valeurs recalculées jusque-là." : `Valeurs figées le ${(c.frozen_at || "").slice(0, 10)} · payé ${formatEUR(c.paid_total)} · reste ${formatEUR(c.reste_a_payer)}`}
      </div>
      {payable && !paying && <button type="button" className="btn-primary mt-3" onClick={() => setPaying(true)} data-testid="commission-block-pay-btn">Enregistrer un paiement</button>}
      {payable && paying && <div className="mt-3"><PaymentForm commission={c} onDone={(nc) => { setPaying(false); setC(nc); }} onCancel={() => setPaying(false)} /></div>}
    </div>
  );
}
